import { useCallback } from 'react';

import useAsyncRequest from '../../../hooks/useAsyncRequest';
import { getReleaseGroupReleases } from '../../api/organization';
import useSlug from '../../hooks/useSlug';

const useReleaseGroupReleases = (releaseGroupId: number) => {
  const slug = useSlug();
  const getReleaseGroupsReq = useCallback(() => getReleaseGroupReleases(slug, releaseGroupId), [slug, releaseGroupId]);
  return useAsyncRequest(getReleaseGroupsReq);
};

export default useReleaseGroupReleases;
